export default "__VITE_ASSET__DvFQxg0R__"